// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { FeatureResponse_abstract } from './../abstract/SagaBase/FeatureResponse_abstract';
export class FeatureResponse extends FeatureResponse_abstract {}
